//* Libraries imports
import { FaFileAlt, FaEdit, FaTrashAlt } from "react-icons/fa";
import { motion } from "framer-motion"; 
import styles from "../styles/resource-question-actions.module.scss";

//* Components imports
import Icon from "../../../../../../components/common/Icon";

type ResourceQuestionActionsProps = {
  resourceId: string;
  onViewClick?: () => void;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
  hideEdit?: boolean;
  hideDelete?: boolean;
  hideView?: boolean;
};

export function ResourceQuestionActions({
  resourceId,
  onViewClick,
  onEditClick,
  onDeleteClick,
  hideEdit = false,
  hideDelete = false,
  hideView = false,
}: ResourceQuestionActionsProps) {
  const buttonVariants = {
    hover: { scale: 1.1, transition: { duration: 0.2 } },
    tap: { scale: 0.9 },
  };

  return (
    <div className={styles.actionsContainer}>
      {onViewClick && !hideView && (
        <motion.div
          variants={buttonVariants}
          whileHover="hover"
          whileTap="tap"
          className={`${styles.actionButton} ${styles.viewButton}`}
          onClick={onViewClick}
          title="Visualizar recurso"
          role="button"
          aria-label="Visualizar recurso"
        >
          <Icon icon={FaFileAlt} size={20} />
        </motion.div>
      )}
      
      {!hideEdit && onEditClick && (
        <motion.div
          variants={buttonVariants}
          whileHover="hover"
          whileTap="tap"
          className={`${styles.actionButton} ${styles.editButton}`}
          onClick={onEditClick}
          title="Editar recurso"
          role="button"
          aria-label="Editar recurso"
        >
          <Icon icon={FaEdit} size={20} />
        </motion.div>
      )}
      
      {!hideDelete && onDeleteClick && (
        <motion.div
          variants={buttonVariants}
          whileHover="hover"
          whileTap="tap"
          className={`${styles.actionButton} ${styles.deleteButton}`}
          onClick={onDeleteClick}
          title="Excluir recurso"
          role="button"
          aria-label="Excluir recurso"
        >
          <Icon icon={FaTrashAlt} size={20} />
        </motion.div>
      )}
    </div>
  );
}
